import { render, staticRenderFns } from "./realEstateTreasureRent.vue?vue&type=template&id=0d50b612&"
import script from "./realEstateTreasureRent.vue?vue&type=script&lang=js&"
export * from "./realEstateTreasureRent.vue?vue&type=script&lang=js&"
import style0 from "./realEstateTreasureRent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports